import React, { useState } from "react";
import styled from "styled-components";
import { CARGO_FILTER_OPTIONS, SORT_OPTIONS } from "../../../utils/userFilters";
import SearchBar from "../../common/Search/SearchBar";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 8px 40px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  height: 53px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 20px;
    height: auto;
  }
`;

const AtivosText = styled.div`
  font-size: 18px; 
  color: #6AB8A8;
  font-weight: bold;
  margin-left: 0px;
  margin-right: 20px;
`;

const TextAndButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6AB8A8;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  position: relative;

  span {
    font-size: 18px;
    margin-left: 10px;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 5px;
`;

const DropdownItem = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  color: black;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const WelcomeText = styled.div`
  font-size: 18px; 
  font-weight: 600;
  margin-right: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 37px;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 10px;
    margin-right: 0;
  }
`;

const UsersAtivosHeader = ({ onFilterChange, onSortChange, searchValue = '', onSearchChange }) => {
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);

  const handleFilterSelect = (cargoId) => {
    onFilterChange && onFilterChange(cargoId);
    setShowFilterDropdown(false);
  };

  const handleSortSelect = (sortBy, order) => {
    onSortChange && onSortChange({ sortBy, order });
    setShowSortDropdown(false);
  };

  return (
    <Container>
      <TextAndButtons>
      <WelcomeText>USUÁRIOS</WelcomeText>
        <span 
          className="material-symbols-outlined" 
          style={{ fontSize: '30px', color: '#002E3B' }}
        >
          person
        </span>
        <AtivosText>Ativos</AtivosText>
        <Button onClick={() => setShowFilterDropdown(!showFilterDropdown)}>
          Filtrar
          <span className="material-symbols-outlined">filter_list</span>
          {showFilterDropdown && (
            <Dropdown>
              {CARGO_FILTER_OPTIONS.map((option) => (
                <DropdownItem
                  key={option.value}
                  onClick={() => handleFilterSelect(option.value)}
                >
                  {option.label}
                </DropdownItem>
              ))}
            </Dropdown>
          )}
        </Button>
        <Button onClick={() => setShowSortDropdown(!showSortDropdown)}>
          Ordenar
          <span className="material-symbols-outlined">sort</span>
          {showSortDropdown && (
            <Dropdown>
              {SORT_OPTIONS.map((option, index) => (
                <DropdownItem
                  key={index}
                  onClick={() => handleSortSelect(option.value, option.order)}
                >
                  {option.label}
                </DropdownItem>
              ))}
            </Dropdown>
          )}
        </Button>
      </TextAndButtons>
      <SearchBarWrapper>
        <SearchBar
          placeholder="Pesquisar por nome ou email"
          value={searchValue}
          onChange={(event) => onSearchChange?.(event.target.value)}
        />
      </SearchBarWrapper>
    </Container>
  );
};

export default UsersAtivosHeader;
